import { Adjunto } from '@/app/models/interface/adjunto.model';
import { Component, Input } from '@angular/core';
import { Editor } from 'primeng/editor';

@Component({
  selector: 'c-modal-adjuntos',
  templateUrl: './modal-adjuntos.component.html',
  styleUrl: './modal-adjuntos.component.css',
  standalone: false,
})
export class ModalAdjuntosComponent {
  visible = false;
  @Input() editor!: Editor;

  @Input() adjuntos: Adjunto[] = [];

  range!: { index: number; length: number };

  add(url: string) {
    const quill = this.editor.getQuill();
    const index = this.range ? this.range.index : quill.getLength();

    // Inserta una imagen en la posición del cursor
    if (url.includes('.mp4')) quill.insertEmbed(index, 'video', url);
    else if (url.includes('.pdf')) {
      const iframeHTML = `<iframe src="${url}" width="100%" height="750px" frameborder="0" allowfullscreen="true"></iframe>`;
      quill.clipboard.dangerouslyPasteHTML(index, iframeHTML);
    } else quill.insertEmbed(index, 'image', url);
    // Opcional: Mover el cursor después de la imagen
    quill.insertText(index + 1, '\n', 'user');
    quill.setSelection(index + 2, 0);
    this.close();
  }

  open() {
    const quill = this.editor.getQuill(); // Obtén la instancia de Quill
    this.range = quill.getSelection(); // Obtén la posición del cursor
    this.visible = true;
  }
  close() {
    this.visible = false;
  }

  pushAdjunto(adjunto: Adjunto) {
    const isA = this.adjuntos.find((ad) => ad.id == adjunto.id);
    if (!isA) this.adjuntos.unshift(adjunto);
  }

  remove(id: string) {
    this.adjuntos = this.adjuntos.filter((i) => i.id !== id);
  }
}
